import React, { Component } from "react";
import { SizeMe, SizeMeProps, withSize } from "react-sizeme";
import Ticker from "react-ticker";

class SmartRollText extends Component<{ maxWidth: number } & SizeMeProps> {
  childSize = null;

  state = {
    hover: false,
  };

  hasMouseOver() {
    this.setState({
      hover: true,
    });
  }

  hasMouseOut() {
    this.setState({
      hover: false,
    });
  }
  render() {
    const needed = this.childSize?.width > this.props.maxWidth;

    return (
      <div
        onMouseOver={this.hasMouseOver.bind(this)}
        onMouseOut={this.hasMouseOut.bind(this)}
        style={{ width: "100%" }}
      >
        <SizeMe>
          {(props) => {
            this.childSize = props.size;
            return (
              <div style={{ visibility: "hidden", position: "absolute" }}>
                {this.props.children}
              </div>
            );
          }}
        </SizeMe>
        {needed ? (
          <Ticker speed={2} mode={"smooth"}>
            {() => <>{this.props.children}</>}
          </Ticker>
        ) : (
          <>{this.props.children}</>
        )}
      </div>
    );
  }
}

export default withSize()(SmartRollText);
